import { Asserts, boolean, object, string } from 'yup';

export const creditCardSchema = object({
  firstName: string().trim().min(2).max(64).required(),
  lastName: string().trim().min(2).max(64).required(),
  expDate: string().creditCardExpirationDate().required(),
  cvc: string().creditCardCvc().required(),
  number: string().creditCardNumber().required(),
});

export type CreditCardDataType = Asserts<typeof creditCardSchema>;

export const addCreditCardSchema = creditCardSchema.shape({
  name: string().trim().min(2).max(64).required(),
});

export type AddCreditCardDataType = Asserts<
  typeof addCreditCardSchema
>;

export const updateCreditCardSchema = object({
  name: string().trim().min(2).max(64).required(),
});

export type UpdateCreditCardDataType = Asserts<
  typeof updateCreditCardSchema
> &
  Partial<AddCreditCardDataType>;

export const purchaseCreditCardSchema = creditCardSchema.shape({
  agreement: boolean().required().oneOf([true]),
});

export type PurchaseCreditCardDataType = Asserts<
  typeof purchaseCreditCardSchema
>;
